'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M88.7 389.3c61.1-61.1 122.1-122.1 183.2-183.2 5.7-5.7 11.3-11.3 17-17 11.3 11.3 22.6 22.6 33.9 33.9-5.7 5.7-11.3 11.3-17 17-61.1 61.1-122.1 122.1-183.2 183.2 74 52 183.1 18.1 247.7-39.3l-66.4 0 0-16 108.1-32.4c9.9-14.7 18.9-30.7 27.1-47.6l-71.1 0 0-16 89.6-26.9C492.2 155.2 507.6 53.7 512 0 428.3 6.9 228.5 40.5 137.4 131.6 74.5 194.5 34 311.4 88.7 389.3z', 'M6.1 472l17-17 248.9-248.9 17-17 33.9 33.9-17 17-248.9 248.9-17 17-33.9-33.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;